import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss']
})
export class TimeComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() field;
@Output() onFieldValueUpdated: EventEmitter<Object> = new EventEmitter();
  @Input() builder;
  @Input() translateData: any;
  @Input() model: any;
  @Output() modelChange: EventEmitter<Object> = new EventEmitter();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onError: EventEmitter<Object> = new EventEmitter();
  
    error = false;
    timeData: Date | string;
    time: Date | string;
    durationSlot = 15;
    timeSlots: Array<string> = [];
    errorMessage = '';
    constructor(
      private translationLoader: FuseTranslationLoaderService
    ) {
    }
  
    
  ngOnChanges(changes: any) {

    if (changes && changes.translateData && changes.translateData.currentValue) {
      this.translateData = changes.translateData.currentValue;
      this.translationLoader.loadTranslationsV2(this.translateData);    
    }
  }

    ngOnInit() {
      this.translationLoader.loadTranslationsV2(this.translateData);

      this.durationSlot = this.field['durationSlot'] || this.durationSlot;
      let mins = 0;
      // tslint:disable-next-line:radix
      this.durationSlot = parseInt(this.durationSlot + '');
      let i = 0;
      while (i < 24) {
        if (mins >= 60) {
          mins = 0;
          i++;
        }
        // mins = (mins > 60) ? 0 : mins;
        this.timeSlots.push(((i < 10) ? '0' + i : '' + i) + ':' + ((mins < 10) ? '0' + mins : '' + mins));
        mins += this.durationSlot;
      }

      if (this.field['required'] && (!this.model)) {
        this.error = true;
        this.errorMessage = 'ct.field_is_required';
        if (!this.model) {
          this.onError.emit({
            error: true,
            label: this.field['label']
          });
        }
      }
    }
  
    ondateChange() {
      this.model = this.time;
      this.modelChange.next(this.time);
      if (this.field['required'] && (!this.time)) {
        this.errorMessage = 'ct.field_is_required';
        this.error = true;
        this.onError.emit({
          error: true,
          label: this.field['label']
        });
      } else {
        this.errorMessage = '';
        this.error = false;
        this.onError.emit({
          error: false,
          label: this.field['label']
        });
      }
      if (this.field.haveRules) {
        this.onFieldValueUpdated.emit({
          label: this.field.label,
          value: this.model,
          ruleIndex: this.field.ruleIndex,
          field: this.field
        });
      }
    }
  
    ngAfterViewInit() {

      if (!this.model) {
        if (this.field.default_value === 'now') {
          this.model = new Date();
          this.time = moment(this.model).format('HH:mm');
          this.time = this.getNearestTime(this.time);
        } else if (this.field.default_value === 'empty') {
          this.model = null;
        }
        this.ondateChange();
      } else {
        this.model = this.model;
        this.time = this.model;
      }
      this.timeData = this.model;
    }
  
    
    getNearestTime(time: string): string {
      let tempTime = 0;
      if (time) {
        // tslint:disable-next-line:radix
        const min = (time.split(':') && time.split(':')[1] && parseInt(time.split(':')[1])) || 0;
        while (tempTime < min && tempTime < 60) {
          tempTime += this.durationSlot;
        }
        if (tempTime === 60) {
          tempTime = 0;
          // tslint:disable-next-line:radix
          time = (time.split(':') && time.split(':')[0] && (parseInt(time.split(':')[0]) + 1)) + ':' + ((tempTime < 10) ? '0' + tempTime : '' + tempTime);
        } else {
          time = (time.split(':') && time.split(':')[0]) + ':' + ((tempTime < 10) ? '0' + tempTime : '' + tempTime);
        }
      }
      return time;
    }

}
